import React from "react";
import { useAttachmentUrl } from "../../../hooks/useAttachmentUrl";
import { preventNavigationIfUnavailable } from "../../../hooks/preventNavigationIfUnavailable";

export function AttachmentImageLink({ sourceUrl, attachmentId, fileName, className, imageClassName, alt }) {
    const { hasError, resolvedUrl } = useAttachmentUrl(sourceUrl, attachmentId);

    return (
        <a
            href={resolvedUrl || "#"}
            target="_blank"
            rel="noreferrer"
            className={className}
            onClick={event => preventNavigationIfUnavailable(event, resolvedUrl)}
            aria-disabled={!resolvedUrl}
        >
            {!resolvedUrl && !hasError && (
                <div className={`${imageClassName} cors-attachment__loading`} />
            )}
            {resolvedUrl && (
                <img
                    src={resolvedUrl}
                    alt={alt || fileName || "Attachment"}
                    className={imageClassName}
                />
            )}
        </a>
    );
}

export function AttachmentFileLink({ sourceUrl, attachmentId, fileName, className, children }) {
    const { resolvedUrl } = useAttachmentUrl(sourceUrl, attachmentId);

    return (
        <a
            href={resolvedUrl || "#"}
            target="_blank"
            rel="noreferrer"
            download={fileName || true}
            className={className}
            onClick={event => preventNavigationIfUnavailable(event, resolvedUrl)}
            aria-disabled={!resolvedUrl}
        >
            {children}
        </a>
    );
}

export function AttachmentVideo({ sourceUrl, attachmentId, className }) {
    const { resolvedUrl } = useAttachmentUrl(sourceUrl, attachmentId);

    if (!resolvedUrl) {
        return <div className={`${className} cors-attachment__loading`} />;
    }

    return (
        <video className={className} controls preload="metadata">
            <source src={resolvedUrl} />
            Your browser does not support HTML5 video.
        </video>
    );
}